import React, {Component} from 'react';
import {connect} from 'react-redux';
import Button from '@material-ui/core/Button';
import Cancel from '@material-ui/icons/Cancel';
import {showNotification} from 'react-admin';
import {push} from 'react-router-redux';
import fetchOk from '../utils/fetchOk';

class BookingCancelButton extends Component {
  state = {
    loading: false
  };

  handleClick = (e) => {
    const {push, record, showNotification} = this.props;

    const fetchHeaders = {
      'Authorization': `Bearer ${window.localStorage.getItem('token')}`,
      'X-HOTEL': process.env.REACT_APP_HOTEL
    };
    if (!window.confirm('Voulez-vous vraiment annuler cette réservation ?')) {
      showNotification('Erreur : vous n\'avez pas confirmé l\'annulation', 'warning')
    } else {
      this.setState({loading: true});
      const entrypointUrl = new URL(process.env.REACT_APP_API_ENTRYPOINT);
      const cancel_uri = new URL(`${record.id}/cancel`, entrypointUrl);
      fetchOk(cancel_uri.toString(), {
        method: 'PATCH',
        headers: new Headers({
          ...fetchHeaders,
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        })
      })
        .then(() => {
          showNotification('La réservation est annulée');
          push('/bookings');
        })
        .catch((e) => {
          showNotification('Erreur : la réservation ne peut être annulée', 'warning')
        })
        .finally(() => {
          this.setState({loading: false});
        })
    }
  }

  render() {
    return <Button label="Annuler" color="secondary" onClick={this.handleClick} variant="flat" disabled={this.state.loading}>
      <Cancel></Cancel>
      &nbsp;Annuler
    </Button>;
  }
}

export default connect(null, {
  showNotification,
  push,
})(BookingCancelButton);
